import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import styles from './index.module.scss';

const CreateFeedbackFormItem: FC<
  PropsWithChildren<{
    label: string;
    labelFor?: string;
    error?: string | null;
    required?: boolean;
  }>
> = ({ label, labelFor, error, required, children }) => {
  return (
    <div className={styles.createFeedbackFormItem}>
      <label htmlFor={labelFor} className={styles.label}>
        <span style={{ color: required ? '#ff0000' : 'transparent' }}>*</span>
        {label}
      </label>
      {children}
      <span className={styles.error}>{error}</span>
    </div>
  );
};

export default CreateFeedbackFormItem;
